import { canUseDOM } from '@progress/kendo-react-common';
/**
 * @hidden
 */
export var THROTTLE_MS = 1000 / 60;
/**
 * @hidden
 */
var createStore = function (reducer) {
    var state;
    var timerId;
    var listeners = [];
    var getState = function () { return state; };
    var dispatch = function (action) {
        state = reducer(state, action);
        if (canUseDOM) {
            window.clearTimeout(timerId);
            timerId = window.setTimeout(function () { return listeners.forEach(function (l) { return l(); }); }, THROTTLE_MS);
        }
    };
    var subscribe = function (listener) {
        listeners.push(listener);
        return function () { return listeners = listeners.filter(function (l) { return l !== listener; }); };
    };
    dispatch({});
    return { getState: getState, dispatch: dispatch, subscribe: subscribe };
};
export default createStore;
